import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { shouldRetry } from './application/hooks/queryPolicy';
import { ErrorBoundary } from './presentation/components/feedback/ErrorBoundary';
import { MockFailureBanner } from './presentation/components/feedback/MockFailureBanner';
import { router } from './presentation/routes/router';

/** Exported so tests can reset the shared cache between cases. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: shouldRetry, staleTime: 15_000, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

/** App root: error boundary → query provider → loud mock-failure banner → router. */
export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MockFailureBanner />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
